export default __webpack_public_path__ + "static/media/case.124c1752.svg";